module.exports = __webpack_public_path__ + "media/images/writer/reservation/img-phone@3x-e256414e25112cc3db4db9cd729c5f04.png";